import { Configs, ConnectionType } from 'Constants';

const getLegalNotice = (connectionType: ConnectionType) =>
  fetch(Configs.pipeMessagesEndpoint || '')
    .then((res) => res.json())
    .then((json) => json as MessagesResponse)
    .then((response) => (connectionType === ConnectionType.DPRO ? response.dproLegalNotice : response.legalNotice))
    .catch(() => '');

export const MessagesService = { getLegalNotice };
